<script setup>
    import { ref } from 'vue'
    import ToolbarFile from '@/components/library/ToolbarFile.vue'
    import WebchatAvatarPreview from '@/views/dash/channels/Pages/WebchatAvatarPreview.vue'

    defineProps({
        badge: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            required: true,
        },
        toolbarTitle: {
            type: String,
            required: true,
        },
        source: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            required: true,
            validator: (value) => ['agent', 'bubble'].includes(value),
        },
        avatar: {
            type: String,
            default: '',
        },
        bgColor: {
            type: String,
            default: '#000000',
        },
        previewTitle: {
            type: String,
            default: 'Atendimento',
        },
        bubbleSize: {
            type: Number,
            default: 76,
        },
    })

    const emit = defineEmits(['selected'])

    const expanded = ref(false)

    function toggleExpanded() {
        expanded.value = !expanded.value
    }

    function handleSelected(item) {
        emit('selected', item)
    }
</script>

<template>
    <div class="rounded-lg border border-gray-200 dark:border-neutral-600 bg-white dark:bg-neutral-900/40 p-4">
        <button
            type="button"
            class="flex w-full items-center justify-between gap-3 text-left"
            :aria-expanded="expanded"
            @click="toggleExpanded"
        >
            <div class="flex min-w-0 flex-wrap items-center gap-2">
                <span
                    class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 dark:bg-neutral-700 dark:text-gray-200"
                >
                    {{ badge }}
                </span>
                <span class="text-sm font-medium text-gray-900 dark:text-gray-400">
                    {{ title }}
                </span>
            </div>
            <span class="flex shrink-0 items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
                {{ expanded ? 'Ocultar preview' : 'Ver preview' }}
                <Unicon
                    :name="expanded ? 'angle-up' : 'angle-down'"
                    class="h-4 w-4"
                />
            </span>
        </button>

        <div
            v-show="expanded"
            class="mt-3"
        >
            <WebchatAvatarPreview
                :variant="variant"
                :avatar="avatar"
                :bg-color="bgColor"
                :title="previewTitle"
                :bubble-size="bubbleSize"
            />
        </div>

        <div class="mt-3 space-y-2">
            <ToolbarFile
                type="image"
                :title="toolbarTitle"
                :source="source"
                @selected="handleSelected"
            />
            <p class="text-xs text-gray-400 dark:text-gray-400">
                {{ hint }}
            </p>
        </div>
    </div>
</template>
